import React, { useEffect } from 'react';
import ProjectCard from './ProjectCard.jsx';
import useScrollReveal from '../hooks/useScrollReveal.jsx';

const AboutWork = ({ projects }) => {
    useScrollReveal();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="work-page">
            <section className="work" id="work">
                <div className="container">
                    <div className="section-header" data-scroll-reveal>
                        <span className="section-number">02</span>
                        <h2 className="section-title">Selected Work</h2>
                        <p className="work-intro">
                            Explore my portfolio of projects spanning web design, mobile apps, branding,
                            and digital experiences. Each project represents a unique challenge and creative solution.
                        </p>
                    </div>
                    <div className="work-grid">
                        {projects.map((project, index) => (
                            <ProjectCard key={index} project={project} />
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
export default AboutWork;